import {Grid, Link} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import React, {useCallback, useState} from 'react'

import {ContentDetailsItem} from 'src/api/types'
import arrowSrc from 'src/shared/assets/arrow.svg'
import infoSrc from 'src/shared/assets/info.svg'

import {useIsMobile} from '../../hooks'
import {TextItem} from '../text-item'
import DetailsDesktop from './DetailsDesktop'
import DetailsMobile from './DetailsMobile'
import {classes} from './styles'

type Props = {
  item: ContentDetailsItem
}

const Details: React.FC<Props> = ({item}) => {
  const t = useI18n()
  const [showDrawer, setShowDrawer] = useState(false)
  const setShown = useCallback(() => setShowDrawer(true), [])
  const setHidden = useCallback(() => setShowDrawer(false), [])

  const isMobile = useIsMobile()
  const DetailsModal = isMobile ? DetailsMobile : DetailsDesktop

  return (
    <>
      <Grid
        alignItems="center"
        className={classes.root}
        component={Link}
        onClick={setShown}
        size="m"
        wrap="nowrap"
        container
      >
        <Grid item>
          <img alt="" loading="lazy" src={infoSrc} />
        </Grid>
        <Grid item xs>
          <TextItem item={item.title} />
          {item.subtitle && <TextItem item={item.subtitle} />}
        </Grid>
        <Grid item>
          <img alt="" className={classes.arrowIcon} data-e2e="openDetails" loading="lazy" src={arrowSrc} />
        </Grid>
      </Grid>

      {showDrawer && (
        <DetailsModal
          classes={classes}
          onClose={setHidden}
          sections={item.sections}
          title={item.title?.text || t('route_order_details')}
        />
      )}
    </>
  )
}

export default Details
